import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TokenService } from '@app/auth/services/token.service';
import { AuthEndpoint } from '@app/constants/auth-constants';
import { SERVER_URL } from '@app/constants/endpoints.constants';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private _tokenService: TokenService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(SERVER_URL) && !request.url.includes(AuthEndpoint.Token)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this._tokenService.getAccessToken()}`
        }
      });
    }
    return next.handle(request);
  }
}
